import { DeathRelatedInfoType } from "../../types/commonTypes/deathRelatedInfoType";

export const initialDeathRelatedInfoState: DeathRelatedInfoType = {
    dateOfDeath: "",
    abroad: false,
    postalCode: "",
    country: "",
    cities: [],
    city: "",
  };
  